import React from 'react';
import PropTypes from 'prop-types';
import SelectParkingStandaloneForm from './select-parking-standalone-form';
import { PRODUCT_TYPE_PARKING } from '../../../general/js/basket/constants';
import ProductsHelper from './products-helper';
import TicketBuilderAside from './ticket-builder-aside';
import CheckoutButton from './checkout-button';
import { ROUTE_PARKING_STANDALONE } from './constants';
import BasketDialogBoxContentBody from '../../../general/js/basket/basket-dialog-box-content-body';
import ConfirmationModal from '../../sso/components/common/utility/ConfirmationModal';

export default class SelectParkingStandalonePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };
        this.toggleConfirmationModal = this.toggleConfirmationModal.bind(this);
        this.toggleCloseModal = this.toggleCloseModal.bind(this);
    }

    toggleConfirmationModal() {
        this.props.showDialogBox ? this.setState({ showModal: true }) : this.setState({ showModal: false });
    }

    onConfirmationModal(mc, onContinue) {
        this.toggleConfirmationModal();

        if (!this.props.showDialogBox)
            this.onCheckout(mc, onContinue)
    }

    toggleCloseModal() {
        this.setState({ showModal: false });
    }

    onCheckout(mc, onContinue) {
        this.props.onStartCheckout(mc);
        this.triggerContinue(onContinue, mc ? 'Pay with Mastercard' : 'Pay');
    }

    onClearParkingSelection() {
        const parkingList = this.getParkingList();
        const paramsList = parkingList.map((parking) =>
            Object.assign({}, {
                type: parking.type,
                tag: parking.tag
            }));

        this.props.onClearSelection(paramsList);
    }

    triggerContinue(onContinue, actionCaption) {
        onContinue(actionCaption, ROUTE_PARKING_STANDALONE);
    }

    getParkingList() {
        return ProductsHelper.getStandaloneProductsList(
            this.props.productGroupsList,
            this.props.basket.productGroups,
            (product) => product.type === PRODUCT_TYPE_PARKING
        );
    }

    onSelectParkingQuantity(...args) {
        this.props.onApplyProductsQuantity(...args);
        this.setState({ isReadyToPay: true, focusCheckout: false });
    }

    render() {
        return (
            <React.Fragment>
                <div className="ticket-builder__main">
                    <SelectParkingStandaloneForm
                        dictionary={this.props.dictionary}
                        productGroupsList={this.props.productGroupsList}
                        currentScenario={this.props.currentScenario}
                        parkingList={this.getParkingList()}
                        onApplyProductsQuantity={this.props.onApplyProductsQuantity}
                        onClearSelection={() => this.onClearParkingSelection()}
                    />
                </div>
                <div className="ticket-builder__aside">
                    <TicketBuilderAside
                        productGroupsList={this.props.productGroupsList}
                        basket={this.props.basket}
                        onToggleBasketMobile={this.props.onToggleBasketMobile}
                        basketUrl={this.props.basketUrl}
                        renderControls={(onContinue) => (
                            <React.Fragment>
                                <div className="ticket-builder__pay-controls">
                                    <CheckoutButton
                                        onStartCheckout={(mc) => this.onConfirmationModal(mc, onContinue)}
                                        isDisabled={!this.getParkingList().some((parking) => parking.quantity > 0)}
                                    />
                                    <div className="throttle">
                                        <span>We are experiencing high volumes of traffic at the minute. Please try again.</span>
                                    </div>
                                </div>
                                <ConfirmationModal
                                    isOpen={this.state.showModal}
                                    inputText={"Pay"}
                                    onModalClose={this.toggleCloseModal}
                                    onApproveClick={(mc) => this.onCheckout(mc, onContinue)}
                                    isApproveDanger={false}
                                    isApproveButtonDisabled={false}
                                    onCancelClick={this.toggleCloseModal}
                                    isCancelButtonDisabled={true}
                                    masterCardDialogBoxBanner={this.props.dialogBoxBanner}
                                >
                                    <BasketDialogBoxContentBody
                                        basketDialogBoxTitle={this.props.dialogBoxTitle}
                                        basketDialogBoxMessage={this.props.dialogBoxMessage}
                                        basketDialogBoxLogo={this.props.dialogBoxLogo}>
                                    </BasketDialogBoxContentBody>
                                </ConfirmationModal>
                            </React.Fragment>
                        )}
                    />
                </div>
            </React.Fragment>
        );
    }
}

SelectParkingStandalonePage.propTypes = {
    dictionary: PropTypes.object.isRequired,
    basket: PropTypes.object,
    productGroupsList: PropTypes.array,
    categoriesList: PropTypes.array,
    currentScenario: PropTypes.string.isRequired,
    onApplyProductsQuantity: PropTypes.func,
    onClearSelection: PropTypes.func,
    onToggleBasketMobile: PropTypes.func,
    onStartCheckout: PropTypes.func,
    dialogBoxTitle: PropTypes.string,
    dialogBoxMessage: PropTypes.string,
    dialogBoxLogo: PropTypes.string,
    showDialogBox: PropTypes.bool
};
